import { FC } from 'react'

import { Button, IButonOptions } from '@UI/crypto_exchange/desktop/components/controls/Button'

import s from './styles.module.scss'

export const ButtonControl: FC<IButonOptions> = (props) => {
  return (
    <Button className={s.button} onClick={props.onClick}>
      {props.children}
    </Button>
  )
}
